import { immer } from "zustand/middleware/immer";

interface NonPersistantUiStoreState {
  isTicketTimelineOpen: boolean;
  isOnboardingDrawerOpen: boolean;
}

interface NonPersistantUiStoreAction {
  toggleTicketTimeline: () => void;
  setOnboardingDrawerOpen: (open: boolean) => void;
}
export interface NonPersistantUiStoreInterface
  extends NonPersistantUiStoreState,
    NonPersistantUiStoreAction {}

export const nonPersistantUiSlice = immer<
  NonPersistantUiStoreState & NonPersistantUiStoreAction
>((set) => ({
  isTicketTimelineOpen: false,
  isOnboardingDrawerOpen: false,
  selectedTicketData: [],
  toggleTicketTimeline() {
    set((state) => {
      state.isTicketTimelineOpen = !state.isTicketTimelineOpen;
    });
  },
  setOnboardingDrawerOpen(open) {
    set((state) => {
      state.isOnboardingDrawerOpen = open;
    });
  },
}));
